<ng-container *ngIf="typeOfToolTip === 'button'">
  <button class="mapfre tooltip waves-light {{additionalClasses}}"
    [mdbTooltip]="toolTipPlacement"  
    mdbRipple>
    <ng-content></ng-content>
  </button>
</ng-container>

<ng-container *ngIf="typeOfToolTip === 'text'">
  <span [mdbTooltip]="toolTipPlacement"
    class="{{additionalClasses}}"
    trigger="" #example="mdbTooltip">
    <ng-content></ng-content>
  </span>
</ng-container>
